import React, { useEffect, useState } from "react";
import PopupModal from "../../common/PopupModal";
import CgFormCreator from "../../common/CgFormCreator";
import "./AddAgesTreated.scss";
import { useDispatch, useSelector } from "react-redux";
import {
  fetchagesTreadedTedails,
  fetchUpdateagesTreated,
} from "../../store/dashboard/AddAgesTreatedActions";

const addAgesTreatedMinimumAgeRadioOptions = [
  {
    code: "no minimum",
    name: "no minimum",
  },
  {
    code: "min",
    name: "",
  },
];

const addAgesTreatedMaximumAgeRadioOptions = [
  {
    code: "no maximum",
    name: "no maximum",
  },
  {
    code: "max",
    name: "",
  },
];

const AddAgesTreated = ({
  openPopupModal,
  closePopupCallBack = () => {},
  providerId,
  practiceId,
}) => {
  const [openAddAgesTreatedPopup, setOpenAddAgesTreatedPopup] = useState(false);
  const [agesTreatedValues, setAgesTreatedValues] = useState({
    minimumAge: "",
    maximumAge: "",
    youngestAgeTreated: "",
    oldestAgeTreated: "",
  });

  const dispatch = useDispatch();

  const { agesTreatedData, isAgesTreatedDataLoading } = useSelector(
    (state) => state.addAgesTreated
  );

  useEffect(() => {
    dispatch(
      fetchagesTreadedTedails({
        practiceId,
        providerId: providerId,
      })
    );
  }, []);

  useEffect(() => {
    setOpenAddAgesTreatedPopup(openPopupModal);
  }, [openAddAgesTreatedPopup]);

  const addAgesTreatedSchema = [
    {
      component: "radio",
      name: "minimumAge",
      className: "addAgesTreated",
      defaultValue: agesTreatedData?.youngestAgeTreated ? "min" : undefined,
      options: addAgesTreatedMinimumAgeRadioOptions,
      keyValues: { label: "name", value: "code" },
      onSelect: (name, value) => {
        setAgesTreatedValues({ ...agesTreatedValues, minimumAge: value });
      },
      customRenderLabel: () => {
        return <div className="addAgesTreatedLabel">Minimum Age:</div>;
      },
    },
    {
      component: "input",
      label: " ",
      type: "number",
      name: "youngestAgeTreated",
      className:
        agesTreatedValues?.minimumAge === "min" &&
        agesTreatedValues?.youngestAgeTreated?.length === 0
          ? "youngestAgeTreatedErrorBorder"
          : "minAgeField",
      disabled:
        agesTreatedValues?.minimumAge?.length > 0 &&
        agesTreatedValues?.minimumAge === "no minimum"
          ? true
          : false,
      placeholder: " ",
      defaultValue: agesTreatedData?.youngestAgeTreated,
      onKeyChangeCallback: (name, value) => {
        setAgesTreatedValues({
          ...agesTreatedValues,
          [name]: value,
          minimumAge: "min",
        });
      },
      valueChangeCallback: () => {},
    },
    {
      component: "radio",
      name: "maximumAge",
      className: "oldestAgesTreated",
      defaultValue: agesTreatedData?.oldestAgeTreated ? "max" : undefined,
      options: addAgesTreatedMaximumAgeRadioOptions,
      keyValues: { label: "name", value: "code" },
      onSelect: (name, value) => {
        setAgesTreatedValues({ ...agesTreatedValues, maximumAge: value });
      },
      customRenderLabel: () => {
        return <div className="addAgesTreatedLabel">Maximum Age:</div>;
      },
    },
    {
      component: "input",
      label: " ",
      type: "number",
      name: "oldestAgeTreated",
      className:
        agesTreatedValues?.maximumAge === "max" &&
        agesTreatedValues?.oldestAgeTreated?.length === 0
          ? "oldestAgeTreatedErrorBorder"
          : "maxAgeField",
      disabled:
        agesTreatedValues?.maximumAge?.length > 0 &&
        agesTreatedValues?.maximumAge === "no maximum"
          ? true
          : false,
      placeholder: " ",
      defaultValue: agesTreatedData?.oldestAgeTreated,
      onKeyChangeCallback: (name, value) => {
        setAgesTreatedValues({
          ...agesTreatedValues,
          [name]: value,
          maximumAge: "max",
        });
      },
      valueChangeCallback: () => {},
    },
  ];

  const handleDisablePrimaryButton = () => {
    if (
      (agesTreatedValues?.minimumAge === "min" &&
        agesTreatedValues?.youngestAgeTreated?.length === 0) ||
      (agesTreatedValues?.maximumAge === "max" &&
        agesTreatedValues?.oldestAgeTreated?.length === 0)
    ) {
      return false;
    }
    return true;
  };

  const RenderAddAgesTreatedForm = () => {
    if (isAgesTreatedDataLoading) return null;
    return (
      <>
        <div>
          <p className="addAgesTreatedHeader">Add Ages Treated</p>
          <hr />
        </div>
        <CgFormCreator
          onSubmitCallback={(formData) => {
            let payload = {
              youngestAgeTreated:
                formData?.minimumAge === "no minimum"
                  ? 1
                  : parseInt(formData?.youngestAgeTreated),
              oldestAgeTreated:
                formData?.maximumAge === "no maximum"
                  ? 99
                  : parseInt(formData?.oldestAgeTreated),
            };
            dispatch(
              fetchUpdateagesTreated({
                practiceId,
                providerId: providerId,
                data: payload,
              })
            ).then(() => {
              closePopupCallBack();
            });
            // handleAddAgesTreatedForm(formData);
          }}
          onCancel={() => {
            closePopupCallBack();
          }}
          primaryButton="SAVE"
          formClassName="addAgesTreatedForm"
          formHeader="Add Ages Treated"
          schema={addAgesTreatedSchema}
          enablePrimaryBtn={handleDisablePrimaryButton()}
        />
      </>
    );
  };

  const RenderAddAgesTreatedPopup = () => {
    return (
      <div>
        <PopupModal
          isOpen={openAddAgesTreatedPopup}
          onClose={() => {
            setOpenAddAgesTreatedPopup(false);
            closePopupCallBack();
          }}
          onSave={() => {}}
          enableSave={false}
          customRender={RenderAddAgesTreatedForm}
        />
      </div>
    );
  };

  return RenderAddAgesTreatedPopup();
};

export default AddAgesTreated;
